import apiClient from '../api/apiClient';
import purchaseDealSheetService from './purchaseDealSheetService';

const BASE = '/api/v1/admin/suppliers';

const multipartConfig = {
  transformRequest: [
    (data, headers) => {
      if (typeof FormData !== 'undefined' && data instanceof FormData) {
        if (headers?.delete) headers.delete('Content-Type');
        else if (headers) {
          delete headers['Content-Type'];
          delete headers['content-type'];
        }
      }
      return data;
    },
  ],
};

const getSection = async (supplierId, section) => {
  const response = await apiClient.get(`${BASE}/${supplierId}/profile`, {
    params: { section },
  });
  return response?.data?.data || {};
};

const supplierProfileService = {
  getPersonalInfo: (supplierId) => getSection(supplierId, 'personal_info'),
  getBankDetails: (supplierId) => getSection(supplierId, 'bank_details'),
  getDematDetails: (supplierId) => getSection(supplierId, 'demat_details'),
  getPortfolio: (supplierId) => getSection(supplierId, 'portfolio'),

  addBankAccount: async (supplierUuid, payload) => {
    const response = await apiClient.post(`${BASE}/${supplierUuid}/bank-accounts`, payload);
    return response.data;
  },

  setPrimaryBankAccount: async (supplierUuid, bankUuid) => {
    const response = await apiClient.patch(
      `${BASE}/${supplierUuid}/bank-accounts/${bankUuid}/set-primary`
    );
    return response.data;
  },

  deleteBankAccount: async (supplierUuid, bankUuid) => {
    const response = await apiClient.delete(
      `${BASE}/${supplierUuid}/bank-accounts/${bankUuid}`
    );
    return response.data;
  },

  uploadDematCmr: async (supplierUuid, formData) => {
    const response = await apiClient.post(`${BASE}/${supplierUuid}/demat/upload-cmr`, formData, multipartConfig);
    return response.data;
  },

  getBankMismatchPendingReview: async (supplierUuid) => {
    const response = await apiClient.get(`${BASE}/${supplierUuid}/bank-mismatch/pending-review`);
    return response?.data?.data ?? response?.data ?? {};
  },

  verifyBankMismatchDocument: async (supplierUuid, documentId, status) => {
    const response = await apiClient.patch(
      `${BASE}/${supplierUuid}/documents/${encodeURIComponent(documentId)}/verify`,
      { status }
    );
    return response.data;
  },

  uploadBankMismatchCheque: async (supplierUuid, formData) => {
    const response = await apiClient.post(
      `${BASE}/${supplierUuid}/bank-mismatch-cheque`,
      formData,
      multipartConfig
    );
    return response.data;
  },

  listTransactions: async (supplierNumericId, params = {}) => {
    return purchaseDealSheetService.listDealSheets({
      supplier_id: supplierNumericId,
      page: 1,
      limit: 10,
      sort_by: 'id',
      sort_order: 'desc',
      ...params,
    });
  },
};

export default supplierProfileService;
